import { render, staticRenderFns } from "./messaging.vue?vue&type=template&id=74146816&"
import script from "./messaging.vue?vue&type=script&lang=js&"
export * from "./messaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports